function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../_snowpack/pkg/react.js';
import styled from '../../_snowpack/pkg/styled-components.js';
const defaultSize = '26px';

const setWidth = ({
  size,
  width
}) => width || size || defaultSize;

const setHeight = ({
  size,
  height
}) => height || size || defaultSize;

const SVG = styled.svg.withConfig({
  displayName: "pin__SVG",
  componentId: "ogor1j-0"
})(["width:", ";height:", ";path{fill:", ";}"], setWidth, setHeight, p => p.fill || 'currentColor');
export default (({
  fill,
  ...rest
}) => /*#__PURE__*/React.createElement(SVG, _extends({
  viewBox: `0 0 26 26`
}, rest, {
  fill: fill
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.0891 2.50946C14.5034 1.79202 15.4207 1.54621 16.1382 1.96042L25.6645 7.46042C26.3819 7.87463 26.6277 8.79202 26.2135 9.50946V9.50946C25.7993 10.2269 24.8819 10.4727 24.1645 10.0585L14.6382 4.55849C13.9207 4.14428 13.6749 3.2269 14.0891 2.50946V2.50946Z",
  fill: "#4C505B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.0712 3.07644L24.7314 8.07644L18.9635 22.0668L6.83914 15.0668L16.0712 3.07644Z",
  fill: "#4C505B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.85709 14.4998C5.2713 13.7824 6.18869 13.5366 6.90612 13.9508L19.8965 21.4508C20.6139 21.865 20.8598 22.7824 20.4455 23.4998V23.4998C20.0313 24.2173 19.1139 24.4631 18.3965 24.0489L5.40612 16.5489C4.68869 16.1347 4.44287 15.2173 4.85709 14.4998V14.4998Z",
  fill: "#4C505B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.42047 16.5958L16.3487 20.5958L8.31759 27.5061L7.45156 27.0061L9.42047 16.5958Z",
  fill: "#4C505B"
})));